<template>
  <div id="validateUser" class="login">
    <div class="login-card row">
      <div class="login-card-logo col-md-7">
        <img v-img-fallback="{ loading: imgBaseUrl + 'pixel.png', error: imgBaseUrl + 'kerlink-light.png' }" :src="imgBaseUrl + 'logo/logo-light.png'" alt="Logo">

        <h4 class="mt-4 text-secondary text-center text-uppercase font-weight-bold">Wanesy Management Center</h4>
      </div>

      <div v-if="expired" class="login-card-form col-md-5">
        <div class="text-white text-center">
          <p>{{ $t('validateUser:linkExpiredError') | capitalize }}</p>
          <p>{{ $t('validateUser:askNewValidationEmailLink') | capitalize }}</p>
        </div>
      </div>

      <div v-else-if="error===1" class="login-card-form col-md-5">
        <div class="text-white text-center">
          <p>{{ $t('serverError:USER_ALREADY_VALIDATED') | capitalize }}</p>
        </div>
      </div>

      <div v-else-if="error===0" class="login-card-form col-md-5">
        <div class="text-white text-center">
          <p>{{ $t('validateUser:unknownError') | capitalize }}</p>
        </div>
      </div>

      <div v-else class="login-card-form col-md-5">
        <div class="text-white text-center">
          <p>{{ $t('validateUser:emailValidated') | capitalize }}</p>
        </div>
        <router-link id="goToLoginLink" to="/login" class="btn btn-secondary btn-block">{{ $t('validateUser:signIn') | capitalize }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { last } from 'lodash-es'
import to from '@/modules/await-to-js'

export default {
  titleKey: 'validateUser',

  data () {
    return {
      expired: false,
      error: null
    }
  },

  created () {
    // Check link validity
    const expiredDate = parseInt(last(location.hash.split('=')))
    this.expired = this.expired && (expiredDate < Date.now())

    if (!this.expired) this.validateUser()
  },

  methods: {
    // Call API
    async validateUser () {
      const token = last(location.hash.split('&')[0].split('='))

      if (process.env.NODE_ENV === 'development') {
        if (token === 'screenshot') {
          return Promise.resolve()
        }
      }

      let error
      [error] = await to(this.$api.validateUser(this.$store.getters.application, token))

      if (error) {
        if (error.response.status === 401) {
          this.expired = true
        } else if (error.response.data && error.response.data.code === 'USER_ALREADY_VALIDATED') {
          this.error = 1
        } else {
          this.error = 0
        }
        return
      }

      this.error = -1
    }
  }
}
</script>
